import Icon from "@/Components/Icon/Icon";
import React from "react";
import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable,
} from "react-beautiful-dnd";

interface InterfaceProps {
  onDrageEnd: (result: DropResult) => void;
  droppableId: string;
  list: {
    key: string;
    component: React.ReactNode;
  }[];
  label?: string;
}

const DraggableRow = ({
  onDrageEnd,
  list,
  droppableId,
  label,
}: InterfaceProps) => {
  return (
    <div>
      {label && <h2>{label}</h2>}
      <DragDropContext onDragEnd={onDrageEnd}>
        <Droppable droppableId={droppableId}>
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef} className="bg-grey bg-[var(--white)] p-[2rem]">
              {list.map((option, i) => (
                <Draggable key={option.key} draggableId={option.key} index={i}>
                  {(provided, { isDragging }) => {
                    return (
                      <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        <div className="flex border border-dark px-8 py-4 text-center">
                          <div className="mr-8 flex items-center">
                            <Icon
                              className="h-5 w-5 fill-primary"
                              variants="bars"
                            />
                          </div>
                          {option.component}
                        </div>
                      </div>
                    );
                  }}
                </Draggable>
              ))}
              {provided?.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default DraggableRow;
